import { Method } from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import api from 'services/api';

import MinhasSolicitacoesContent from './Content';

import { Content, ModalCustom } from './styles';

const MinhasSolicitacoes = (): JSX.Element => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [dataFiltered, setDataFiltered] = useState([]);
  const [filterRequest, setFilterRequest] = useState('refuel');
  const [filterSituation, setFilterSituation] = useState('all');

  const requestAssistancies = async (): Promise<any[]> => {
    const token = localStorage.getItem(
      '@UltragazEmpresarial:accessToken'
    ) as string;
    const customerId = localStorage.getItem(
      '@UltragazEmpresarial:customerId'
    ) as string;
    const customerSiteId = localStorage.getItem(
      '@UltragazEmpresarial:customerSiteId'
    ) as string;

    const header = {
      'Content-Type': 'application/json',
      access_token: token,
    };
    const parameters = {
      method: 'GET' as Method,
      headers: header,
    };

    let result = [];

    try {
      const res = await api.get(
        `/industrial/case/v1/assistancies?_limit=100000&_offset=0&customer-site-id=${customerSiteId}&customer-id=${customerId}&_expand=requestedCase`,
        parameters
      );

      result = res.data?.map((item: any) => ({
        ...item,
        type: 'assistancie',
      }));
    } catch (err: any) {
      const erro = err.response;
      if (erro) {
        const { message } = err.response.data;
        if (err.response.status !== 401) {
          toast.error(message);
        }
      } else if (err.response.status !== 401) {
        toast.error('Ocorreu um erro interno na aplicação');
      }
    }

    return result;
  };

  const requestRefuels = async (): Promise<any[]> => {
    const token = localStorage.getItem(
      '@UltragazEmpresarial:accessToken'
    ) as string;
    const customerId = localStorage.getItem(
      '@UltragazEmpresarial:customerId'
    ) as string;
    const customerSiteId = localStorage.getItem(
      '@UltragazEmpresarial:customerSiteId'
    ) as string;

    const header = {
      'Content-Type': 'application/json',
      access_token: token,
    };
    const parameters = {
      method: 'GET' as Method,
      headers: header,
    };

    let result = [];

    const customerCode = localStorage.getItem(
      '@UltragazEmpresarial:customerCode'
    );
    const customerSiteCode = localStorage.getItem(
      '@UltragazEmpresarial:customerSiteCode'
    );

    const newParams = `&customer-code=${customerCode}&customer-site-code=${customerSiteCode}`;

    try {
      const res = await api.get(
        `/industrial/case/v1/refuels?customer-id=${customerId}&customer-site-id=${customerSiteId}&_limit=100000&_offset=0${newParams}`,
        parameters
      );

      result = res.data?.map((item: any) => ({
        ...item,
        type: 'refuel',
      }));
    } catch (err: any) {
      const erro = err.response;
      if (erro) {
        const { message } = err.response.data;
        if (err.response.status !== 401) {
          toast.error(message);
        }
      } else if (err.response.status !== 401) {
        toast.error('Ocorreu um erro interno na aplicação');
      }
    }

    return result;
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      const refuelsData = await requestRefuels();
      const assistanciesData = await requestAssistancies();
      setData(
        refuelsData
          .concat(assistanciesData)
          .sort((a, b) => {
            // @ts-ignore
            return new Date(b.createdDate) - new Date(a.createdDate);
          })
          .map((item: any) => {
            let status = '';
            if (item?.type === 'assistancie') {
              switch (item?.status?.code) {
                case 'APROVADO':
                case 'EMAND':
                case 'PAUSADA':
                case 'AGADEQ':
                case 'AGMAT':
                case 'ADIADO':
                  status = 'os-em-atendimento';
                  break;
                case 'COMP':
                case 'FECHAR':
                case 'CONFERIDO':
                  status = 'os-finalizada';
                  break;
                case 'CANCEL':
                case 'SEMEXEC':
                  status = 'os-cancelada';
                  break;
                case 'AGPLAN':
                case 'AAPRV':
                case 'APROG':
                default:
                  status = 'os-em-analise';
                  break;
              }
            } else {
              switch (item?.status?.code) {
                case 'PEDAGE':
                case 'AGEREA':
                  status = 'realizado';
                  break;
                case 'SNOREC':
                case 'CANREA':
                case 'ERRO':
                case 'CANCELADO':
                  status = 'cancelado';
                  break;
                case 'AGENDADO':
                  status = 'agendado';
                  break;
                case 'REPROGRAMADO':
                  status = 'reprogramado';
                  break;
                case 'CONFIRMADO':
                  status = 'confirmado';
                  break;
                case 'EM_ROTA':
                  status = 'em-rota';
                  break;
                case 'NAO_ATENDIDO':
                  status = 'nao-atendido';
                  break;
                case 'ATENDIDO':
                  status = 'atendido';
                  break;
                case 'NAO_IDENTIFICADO':
                  status = 'nao-identificado';
                  break;
                case 'AGUCONLOG':
                case 'AGUANA':
                case 'GERPEDAUT':
                case 'RENDATCLI':
                case 'GREOSAUT':
                case 'ERRINT':
                case 'CANEA':
                case 'PEDIDO_EM_ANALISE':
                default:
                  status = 'em-analise';
                  break;
              }
            }

            return {
              ...item,
              statusCode: item?.status?.code,
              status,
              date: moment(item?.createdDate).format('DD/MM/YYYY'),
            };
          }) as any
      );

      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    let dataNew = data as any;

    if (filterRequest !== 'all') {
      dataNew = data?.filter((item: any) => item?.type === filterRequest);
    }

    if (filterSituation !== 'all') {
      dataNew = dataNew?.filter(
        (item: any) => item?.status === filterSituation
      );
    }

    setDataFiltered(dataNew);
  }, [filterRequest, filterSituation, data?.length]);

  return (
    <Content>
      <MinhasSolicitacoesContent
        showModal={showModal}
        setShowModal={setShowModal}
        loading={loading}
        data={dataFiltered}
        filterRequest={filterRequest}
        setFilterRequest={setFilterRequest}
        filterSituation={filterSituation}
        setFilterSituation={setFilterSituation}
      />
      <ModalCustom show={showModal} fullscreen animation={false}>
        <MinhasSolicitacoesContent
          showModal={showModal}
          setShowModal={setShowModal}
          loading={loading}
          data={dataFiltered}
          filterRequest={filterRequest}
          setFilterRequest={setFilterRequest}
          filterSituation={filterSituation}
          setFilterSituation={setFilterSituation}
        />
      </ModalCustom>
    </Content>
  );
};

export default MinhasSolicitacoes;
